export const categories = [
  {
    slug: "manga",
    name: "百合漫画",
    description: "精选国内外优质百合漫画作品推荐，从经典到新番一网打尽",
    icon: "ri-book-open-line",
    color: "primary",
  },
  {
    slug: "anime",
    name: "百合动漫",
    description: "最新百合动漫资讯、番剧推荐与深度解析",
    icon: "ri-film-line",
    color: "accent",
  },
  {
    slug: "novel",
    name: "百合小说",
    description: "原创与同人百合小说精选，感受文字中的细腻情感",
    icon: "ri-pencil-ruler-2-line",
    color: "secondary",
  },
  {
    slug: "cp",
    name: "百合CP",
    description: "热门百合CP盘点、关系解读与同好讨论",
    icon: "ri-hearts-line",
    color: "primary",
  },
  {
    slug: "fanworks",
    name: "同人创作",
    description: "汇聚优秀的百合同人画作、文章与创作交流",
    icon: "ri-brush-line",
    color: "accent",
  },
  {
    slug: "events",
    name: "活动资讯",
    description: "百合同人展、线下聚会、新作发布等最新活动信息",
    icon: "ri-calendar-event-line",
    color: "secondary",
  },
];

export const articles = [
  {
    id: 1,
    slug: "bloom-into-you-review",
    title: "《终将成为你》——百合漫画史上的里程碑之作",
    excerpt: "仲谷鳰笔下的这部作品以细腻的心理描写和独特的叙事手法，重新定义了百合漫画的艺术高度。本文将深入解析这部被誉为\u201C百合漫画金字塔\u201D的经典之作。",
    content: `<p>《终将成为你》（やがて君になる）是由仲谷鳰创作的一部百合漫画，自2015年开始连载以来，迅速在百合漫画爱好者群体中引发巨大反响。这部作品以其独特的叙事视角、深刻的角色塑造和对情感关系的细腻刻画，被誉为百合漫画史上的里程碑之作。</p>
    <h2>故事概述</h2>
    <p>故事围绕高中生小糸侑展开。侑是一个不懂得恋爱为何物的少女，直到她遇见了学生会长七海灯子。灯子外表完美，内心却深藏着对自我的否定。两人在一次偶然的相遇后，灯子向侑告白——但这并非因为爱情，而是因为她觉得侑\u201C不会喜欢上任何人\u201D的特质让她感到安全。</p>
    <p>从此，一段微妙而复杂的情感关系在两人之间展开。侑在帮助灯子的过程中，逐渐开始理解什么是\u201C喜欢\u201D；而灯子也在侑的陪伴下，慢慢学会接纳真实的自己。</p>
    <h2>艺术特色</h2>
    <p>仲谷鳰的画风干净利落，人物表情细腻丰富。她擅长通过细微的面部表情变化和肢体语言来传达角色内心的情感波动。画面中的留白与分镜节奏把控极为精准，营造出一种诗意般的阅读体验。</p>
    <h2>为什么它如此特别</h2>
    <p>与许多传统的百合漫画不同，《终将成为你》并非简单地讲述\u201C女孩子之间的恋爱故事\u201D。它深入探讨了关于自我认同、情感本质和人际关系的哲学性课题。作品中的每一个角色都有着自己独特的成长轨迹和心理动机，使得整个故事呈现出令人惊叹的深度和层次感。</p>
    <h2>影响力与评价</h2>
    <p>自连载以来，《终将成为你》获得了包括\u201C这本漫画真厉害！\u201D在内的多项大奖。2018年被改编为TV动画后，进一步扩大了其影响力。许多评论家认为，这部作品不仅是一部优秀的百合漫画，更是一部超越了题材标签的文学性佳作。</p>`,
    category: "manga",
    categoryName: "百合漫画",
    coverImage: "https://readdy.ai/api/search-image?query=Soft%20pastel%20illustration%20of%20two%20high%20school%20girls%20in%20Japanese%20uniforms%20standing%20under%20cherry%20blossom%20trees%2C%20warm%20spring%20lighting%2C%20gentle%20atmosphere%2C%20anime%20art%20style%20with%20watercolor%20texture%2C%20emotional%20connection%2C%20clean%20composition&width=800&height=500&seq=yuri-article-1&orientation=landscape",
    author: "编辑部",
    date: "2026-07-28",
    readTime: 12,
    tags: ["经典推荐", "漫画解析", "终将成为你", "仲谷鳰"],
    featured: true,
  },
  {
    id: 2,
    slug: "lycoris-recoil-analysis",
    title: "《Lycoris Recoil》——枪战与百合的完美融合",
    excerpt: "这部2022年的原创动画以精良的制作、讨喜的人设和千束与泷奈之间令人心动的互动，在百合动画爱好者中掀起了一股热潮。",
    content: `<p>《Lycoris Recoil》（リコリス・リコイル）是2022年7月播出的原创电视动画，由A-1 Pictures制作。这部作品巧妙地将动作枪战元素与日常温馨的百合互动结合在一起，创造出了一种独特的观看体验。</p>
    <h2>故事背景</h2>
    <p>在看似和平的日本社会中，存在着一个名为\u201CDA\u201D的秘密组织，其旗下的特工少女被称为\u201CLycoris\u201D，负责暗中消除各种威胁。故事的主角锦木千束是一名乐观开朗的天才Lycoris，而井之上泷奈则是一位因任务失误被调来的严肃少女。两人性格迥异，却在朝夕相处中建立起深厚的羁绊。</p>
    <h2>角色魅力</h2>
    <p>千束和泷奈的\u201C反差萌\u201D组合是本作最大的看点。千束的阳光活泼与泷奈的冷静克制形成了鲜明的对比，两人之间的互动既有令人捧腹的喜剧效果，也有触动心弦的温情时刻。声优安济知佳和若山诗音的演绎更是为角色注入了鲜活的生命力。</p>
    <h2>百合元素的自然融入</h2>
    <p>与其他刻意强调百合关系的作品不同，《Lycoris Recoil》将千束与泷奈之间的感情融入到日常生活的细节之中——一起吃饭、一起购物、在关键时刻相互守护。这种自然而真诚的情感表达方式，让百合元素显得真实而动人。</p>`,
    category: "anime",
    categoryName: "百合动漫",
    coverImage: "https://readdy.ai/api/search-image?query=Two%20anime%20style%20girls%20in%20cafe%20uniforms%20one%20with%20long%20black%20hair%20the%20other%20with%20short%20blonde%20hair%2C%20warm%20cafe%20interior%20lighting%2C%20soft%20pastel%20colors%2C%20gentle%20smiling%20atmosphere%2C%20Japanese%20animation%20art%20style&width=800&height=500&seq=yuri-article-2&orientation=landscape",
    author: "动漫部",
    date: "2026-07-25",
    readTime: 8,
    tags: ["原创动画", "Lycoris Recoil", "千束泷奈", "动作百合"],
    featured: true,
  },
  {
    id: 3,
    slug: "whisper-me-a-love-song",
    title: "《恋语轻唱》——音乐与初恋的甜蜜交织",
    excerpt: "竹嶋えく带来的这部校园音乐百合漫画，以清新的画风和甜而不腻的恋爱故事俘获了无数读者的心。",
    content: `<p>《恋语轻唱》（ささやくように恋を唄う）是竹嶋えく创作的百合漫画，讲述了一段以音乐为纽带的校园恋爱故事。这部作品以其甜美的画风和纯粹的情感表达，在百合漫画读者中获得了极高的人气。</p>
    <h2>故事简介</h2>
    <p>高中入学第一天，木野日鞠在新生欢迎会上被轻音部的学姐朝凪依的表演深深吸引。日鞠对依一见钟情，大胆地表达了自己的\u201C喜欢\u201D。然而，两人对\u201C喜欢\u201D的理解却截然不同——日鞠的\u201C喜欢\u201D是粉丝对偶像的憧憬，而依却将其理解为恋爱意义上的喜欢。就这样，一段充满误会与甜蜜的恋爱故事就此展开。</p>
    <h2>作品亮点</h2>
    <p>竹嶋えく的画风极为精美，角色设计可爱而不失个性。作品中对音乐场景的描绘充满感染力，读者仿佛能透过画面听到角色的歌声。情感发展自然流畅，没有刻意的戏剧化冲突，而是通过日常的相处与交流，让两人的感情逐渐升温。</p>`,
    category: "manga",
    categoryName: "百合漫画",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20art%20style%20illustration%20of%20two%20school%20girls%20in%20a%20music%20room%20with%20guitar%20and%20microphone%2C%20soft%20pink%20and%20warm%20lighting%2C%20cherry%20blossom%20petals%20gently%20floating%2C%20romantic%20atmosphere%2C%20clean%20Japanese%20manga%20aesthetic&width=800&height=500&seq=yuri-article-3&orientation=landscape",
    author: "编辑部",
    date: "2026-07-22",
    readTime: 7,
    tags: ["新番推荐", "漫画推荐", "恋语轻唱", "竹嶋えく"],
    featured: false,
  },
  {
    id: 4,
    slug: "yuri-novel-recommendation-2026",
    title: "2026年必读百合小说推荐：十部不容错过的佳作",
    excerpt: "从网络文学到实体出版，百合小说市场正在蓬勃发展。我们为你精选了十部2026年最值得阅读的百合小说。",
    content: `<p>随着百合文化的日益普及，百合小说作为百合内容生态中的重要一环，近年来呈现出蓬勃发展的态势。从网络连载到实体出版，从国内原创到海外译作，优秀的百合小说层出不穷。本文将为读者推荐十部2026年不容错过的百合小说佳作。</p>
    <h2>1. 《她的山，她的海》</h2>
    <p>这是一部清新脱俗的校园百合小说，讲述了两个性格迥异的女孩在高中三年中相互扶持、共同成长的故事。作者以细腻的笔触描绘了青春期少女之间微妙的情感变化，文字如清晨的露珠般纯净动人。</p>
    <h2>2. 《宫墙柳》</h2>
    <p>古风百合小说的代表作之一。故事设定在架空的古代宫廷，两位身份悬殊的女性在权力与情感的漩涡中相互试探、相互守护。文笔典雅优美，情感真挚深沉。</p>
    <h2>3. 《她与她的猫》</h2>
    <p>一部都市职场背景的百合小说，融入了一点奇幻元素。女主角偶然发现自己能和猫对话，而她暗恋的女同事恰好养了一只话痨的橘猫……轻松幽默中带着治愈与温暖。</p>
    <p><em>……更多推荐请阅读全文</em></p>`,
    category: "novel",
    categoryName: "百合小说",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20still%20life%20of%20books%20and%20reading%20nook%20with%20soft%20pink%20and%20cream%20tones%2C%20cherry%20blossom%20branch%20in%20a%20glass%20vase%2C%20warm%20cozy%20lighting%2C%20feminine%20aesthetic%2C%20clean%20and%20minimal%20Japanese%20inspired%20interior&width=800&height=500&seq=yuri-article-4&orientation=landscape",
    author: "小说部",
    date: "2026-07-20",
    readTime: 15,
    tags: ["小说推荐", "2026推荐", "书单", "百合文学"],
    featured: true,
  },
  {
    id: 5,
    slug: "witch-from-mercury-impact",
    title: "《水星的魔女》对百合动画市场的深远影响",
    excerpt: "高达系列首部以女性为主角的作品，斯莱塔与米奥莉奈之间的关系引发了全球范围内的热烈讨论。",
    content: `<p>《机动战士高达：水星的魔女》于2022年10月播出后，以其突破性的设定和引人入胜的剧情迅速成为现象级作品。作为高达系列首部以女性为主角的TV动画，它不仅革新了高达的传统叙事模式，更在百合动画领域产生了深远的影响。</p>
    <h2>突破性的设定</h2>
    <p>斯莱塔·墨丘利作为来自水星的转学生，在第一话结尾的宣言——\u201C我会负责的！\u201D——以及她与米奥莉奈·伦布兰之间令人意想不到的关系发展，彻底打破了高达系列的传统框架。这种打破常规的叙事在当时引发了巨大的讨论热潮。</p>
    <h2>对百合动画市场的影响</h2>
    <p>《水星的魔女》的成功证明了百合元素的商业价值远超业界预期。它打破了\u201C百合是小众题材\u201D的固有认知，向整个动画行业展示了百合叙事可以与主流商业动画完美融合。此后，越来越多的动画制作公司开始重视百合题材的开发。</p>`,
    category: "anime",
    categoryName: "百合动漫",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20anime%20style%20illustration%20of%20two%20female%20pilots%20in%20space%20suits%20standing%20together%20looking%20at%20stars%2C%20soft%20ethereal%20lighting%2C%20pastel%20pink%20and%20white%20color%20scheme%2C%20gentle%20romantic%20mood&width=800&height=500&seq=yuri-article-5&orientation=landscape",
    author: "动漫部",
    date: "2026-07-18",
    readTime: 10,
    tags: ["高达", "水星的魔女", "斯莱塔米奥莉奈", "百合动画"],
    featured: false,
  },
  {
    id: 6,
    slug: "yuri-couple-guide",
    title: "入门必看：十大经典百合CP盘点",
    excerpt: "从经典到新番，我们为你盘点了十对不容错过的百合CP。无论你是新人还是老粉，总有一对能触动你的心。",
    content: `<p>百合CP文化是百合爱好者社群中最活跃的话题之一。每一对经典的百合CP背后，都有着一段令人难忘的故事和无数粉丝的热爱。本文将盘点十对最具代表性的百合CP，为新入坑的百合爱好者提供一份入门指南。</p>
    <h2>1. 小糸侑 \u00D7 七海灯子（《终将成为你》）</h2>
    <p>百合CP中的\u201C教科书级\u201D组合。侑与灯子之间复杂而深刻的情感关系，代表了百合叙事中最为细腻和真实的一面。</p>
    <h2>2. 千束 \u00D7 泷奈（《Lycoris Recoil》）</h2>
    <p>\u201C互相关心、互相守护\u201D的最佳诠释。千束的阳光与泷奈的冷静形成了完美的互补，她们的日常互动是这部作品最温暖的底色。</p>
    <h2>3. 斯莱塔 \u00D7 米奥莉奈（《水星的魔女》）</h2>
    <p>革命性的百合CP组合。从政治联姻到真心相爱，这一对的感情发展打破了无数观众的预期。</p>
    <h2>4. 晓美焰 \u00D7 鹿目圆（《魔法少女小圆》）</h2>
    <p>跨越无数时间线的执念与守护。焰为了拯救小圆不断轮回的决心，将百合情感推向了近乎悲壮的极致境界。</p>
    <p><em>……更多CP推荐请阅读全文</em></p>`,
    category: "cp",
    categoryName: "百合CP",
    coverImage: "https://readdy.ai/api/search-image?query=Soft%20romantic%20anime%20illustration%20of%20two%20girls%20holding%20hands%20under%20starry%20night%20sky%2C%20gentle%20pink%20and%20purple%20gradient%20color%20palette%2C%20dreamy%20atmosphere%2C%20emotional%20connection%2C%20Japanese%20anime%20aesthetic%20with%20soft%20watercolor%20style&width=800&height=500&seq=yuri-article-6&orientation=landscape",
    author: "CP组",
    date: "2026-07-15",
    readTime: 10,
    tags: ["CP盘点", "入门指南", "经典CP", "百合CP"],
    featured: true,
  },
  {
    id: 7,
    slug: "yuri-doujin-guide-2026",
    title: "百合同人创作入门指南：从零开始画出你心中的她",
    excerpt: "想要创作属于自己的百合同人作品却不知从何下手？这份指南将带你一步步踏入百合同人创作的精彩世界。",
    content: `<p>百合同人创作是百合文化中最具活力的组成部分之一。从精美的插图到动人的短篇，从四格漫画到长篇连载，百合同人创作者们用画笔和文字构建了一个丰富多彩的创作生态。</p>
    <h2>第一步：选择你的创作形式</h2>
    <p>百合同人创作的形式多种多样。你可以选择插画、漫画、小说，甚至是手工作品。如果你是绘画初学者，建议从单幅插画开始；如果你擅长文字，短篇小说是一个很好的切入点。</p>
    <h2>第二步：找到你的灵感来源</h2>
    <p>灵感可以来自于你喜爱的百合作品、生活中的观察，或者纯粹是脑海中的想象。多看、多想、多感受，灵感自然会源源不断地涌现。</p>
    <h2>第三步：加入同人社区</h2>
    <p>百合同人社区是一个非常友好和互助的环境。在社区中分享你的作品、接受反馈、结交同好，这些都能帮助你快速成长。</p>`,
    category: "fanworks",
    categoryName: "同人创作",
    coverImage: "https://readdy.ai/api/search-image?query=Art%20studio%20desk%20with%20drawing%20tablet%2C%20sketchbooks%2C%20colored%20pencils%2C%20and%20anime%20style%20sketches%2C%20warm%20morning%20light%20through%20window%2C%20cozy%20creative%20atmosphere%2C%20soft%20pastel%20aesthetic%2C%20clean%20organized%20workspace&width=800&height=500&seq=yuri-article-7&orientation=landscape",
    author: "同人部",
    date: "2026-07-12",
    readTime: 8,
    tags: ["同人创作", "入门指南", "绘画教程", "创作社区"],
    featured: false,
  },
  {
    id: 8,
    slug: "yuri-event-summer-2026",
    title: "2026夏：百合同人展与线下聚会活动汇总",
    excerpt: "夏天是百合爱好者的狂欢季！多场百合同人展和线下聚会即将在全国各地举办，不要错过与同好面对面的机会。",
    content: `<p>2026年夏季，全国各地将举办多场百合主题的同人展与线下聚会活动。这是百合爱好者们走出屏幕、与同好面对面交流的最佳时机！</p>
    <h2>百合同人祭\u00B7上海站</h2>
    <p>时间：2026年8月15日-16日<br/>地点：上海世博展览馆<br/>规模：预计超过200个同人摊位，涵盖漫画、小说、周边等多种品类。</p>
    <h2>百合之夏\u00B7广州</h2>
    <p>时间：2026年8月22日<br/>地点：广州琶洲国际会展中心<br/>亮点：首次设立\u201C百合新人创作奖\u201D评选环节，鼓励新人创作者。</p>
    <h2>帝都百合茶会</h2>
    <p>时间：2026年9月5日<br/>地点：北京朝阳区某咖啡厅（报名后通知具体地址）<br/>形式：小型线下交流聚会，限定30人参加。</p>`,
    category: "events",
    categoryName: "活动资讯",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20convention%20hall%20with%20colorful%20booths%20and%20cosplayers%2C%20warm%20vibrant%20atmosphere%2C%20pink%20and%20white%20decorations%2C%20crowds%20browsing%20art%20prints%20and%20merchandise%2C%20lively%20community%20gathering%2C%20clean%20Japanese%20pop%20culture%20event%20aesthetic&width=800&height=500&seq=yuri-article-8&orientation=landscape",
    author: "活动组",
    date: "2026-07-10",
    readTime: 6,
    tags: ["线下活动", "同人展", "夏季活动", "社交聚会"],
    featured: false,
  },
  {
    id: 9,
    slug: "adachi-to-shimamura-deep-read",
    title: "《安达与岛村》——日常系百合的极致之美",
    excerpt: "入间人间笔下的这部作品以极其细腻的笔触描绘了两个少女之间若即若离的日常，被誉为日常系百合的巅峰之作。",
    content: `<p>《安达与岛村》（安達としまむら）是由入间人间创作、のん负责插画的轻小说系列，后改编为漫画和TV动画。这部作品以其对日常生活极致的细腻描绘和独特的心理叙事，在日常系百合文学中占据了不可撼动的地位。</p>
    <h2>故事简介</h2>
    <p>故事围绕两位高中女生——安达樱与岛村抱月展开。她们在体育馆二楼的天台偶然相遇后，开始了每天放学后一起消磨时间的日常。没有波澜壮阔的剧情，也没有跌宕起伏的冲突，只有两个少女之间缓慢而温柔的情感萌动。</p>
    <h2>写作特色</h2>
    <p>入间人间的文字有一种独特的韵律感。他擅长通过大量的内心独白来展现角色的心理变化，尤其是安达视角的叙述——那些在旁人看来微不足道的细节，在安达的眼中都因为与岛村有关而变得意义非凡。这种极度内向的心理描写让读者能够深入角色的内心世界。</p>
    <h2>动画改编</h2>
    <p>2020年由手冢Production改编的TV动画虽然在制作资源上并不算顶级，但通过精心的声优演绎和氛围营造，成功还原了原作的温柔气质。鬼头明里（安达役）和伊藤美来（岛村役）的表演尤其受到了观众的好评。</p>`,
    category: "novel",
    categoryName: "百合小说",
    coverImage: "https://readdy.ai/api/search-image?query=Two%20high%20school%20girls%20sitting%20on%20school%20rooftop%20during%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20gentle%20atmosphere%2C%20Japanese%20anime%20art%20style%2C%20soft%20watercolor%20and%20pastel%20aesthetic%2C%20quiet%20intimate%20moment&width=800&height=500&seq=yuri-article-9&orientation=landscape",
    author: "小说部",
    date: "2026-07-08",
    readTime: 11,
    tags: ["轻小说", "安达与岛村", "入间人间", "日常系"],
    featured: false,
  },
  {
    id: 10,
    slug: "yuri-anime-2026-summer",
    title: "2026夏季新番百合动画追番指南",
    excerpt: "七月新番季来临，有哪些值得期待的百合向动画？我们为你整理了本季最值得关注的五部作品。",
    content: `<p>2026年夏季新番已经全面开播，本季的百合向动画可谓是精彩纷呈。从轻松治愈的日常系到紧张刺激的奇幻战斗，总有一部适合你的口味。</p>
    <h2>1. 《花与她的约定》</h2>
    <p>原创动画，讲述两位花店少女的温馨日常。画风清新治愈，每一帧都像一幅精致的水彩画。</p>
    <h2>2. 《星空下的旋律》</h2>
    <p>音乐题材的百合动画，讲述管弦乐部中两位少女因音乐结缘的故事。配乐由知名作曲家操刀。</p>
    <h2>3. 《魔女与骑士》</h2>
    <p>奇幻冒险题材，讲述见习魔女与流浪骑士的旅途。战斗场面精彩，人物关系张力十足。</p>`,
    category: "anime",
    categoryName: "百合动漫",
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20style%20collage%20of%20various%20magical%20girl%20characters%20in%20summer%20settings%2C%20vibrant%20warm%20colors%2C%20sunset%20and%20ocean%20background%2C%20diverse%20character%20designs%2C%20Japanese%20animation%20promotional%20art%20style%2C%20energetic%20and%20hopeful%20mood&width=800&height=500&seq=yuri-article-10&orientation=landscape",
    author: "动漫部",
    date: "2026-07-05",
    readTime: 7,
    tags: ["新番推荐", "2026夏季", "追番指南", "新番速递"],
    featured: false,
  },
  {
    id: 11,
    slug: "sakura-trick-legacy",
    title: "《樱Trick》——轻松搞笑的百合日常经典",
    excerpt: "这部以接吻为核心设定的百合动画，用夸张搞笑的方式展现了少女之间亲密的友谊与爱情。",
    content: `<p>《樱Trick》（桜Trick）是タチ创作的四格漫画，于2014年改编为TV动画。这部作品以轻松搞笑的风格和独特的\u201C接吻\u201D设定，在百合动画史上留下了浓墨重彩的一笔。</p>
    <h2>独特设定</h2>
    <p>故事设定在一个三年后就要废校合并的高中，两位主角高山春香与园田优为了在毕业前留下特别的回忆而接吻——从此一发不可收拾。每一话都有接吻场景的设定让这部作品在百合动画中独树一帜。</p>
    <h2>轻松愉快的基调</h2>
    <p>与许多探讨深刻情感的百合作品不同，《樱Trick》选择了一种轻松愉快的叙事方式。夸张的搞笑桥段、可爱的画风和甜蜜的互动让观众在欢笑中感受百合的美好。</p>`,
    category: "anime",
    categoryName: "百合动漫",
    coverImage: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20illustration%20of%20two%20school%20girls%20in%20sailor%20uniforms%20sharing%20a%20playful%20moment%20in%20a%20classroom%2C%20bright%20cheerful%20colors%2C%20cherry%20blossom%20petals%2C%20lighthearted%20atmosphere%2C%20chibi%20style%20elements&width=800&height=500&seq=yuri-article-11&orientation=landscape",
    author: "编辑部",
    date: "2026-07-02",
    readTime: 6,
    tags: ["经典推荐", "樱Trick", "搞笑百合", "动画推荐"],
    featured: false,
  },
  {
    id: 12,
    slug: "yuri-culture-history",
    title: "百合文化简史：从大正浪漫到令和时代",
    excerpt: "追溯百合文化在日本的历史渊源，从S文学到现代百合漫画，了解这一独特文化现象的发展脉络。",
    content: `<p>百合文化作为日本ACG文化中一个重要的分支，有着悠久而丰富的历史渊源。从大正时代的\u201CS文学\u201D到令和时代的多元百合表达，百合文化经历了近百年的演变与发展。</p>
    <h2>大正到昭和初期：S文学的兴起</h2>
    <p>百合文化的前身可以追溯到大正时代的\u201CS文学\u201D（エス文学）。S取自\u201CSister\u201D的首字母，指的是描绘女校中高年级与低年级学生之间亲密关系的文学作品。吉屋信子的《花物语》系列是这一时期的代表作。</p>
    <h2>昭和后期：少女漫画中的百合萌芽</h2>
    <p>1970年代，以萩尾望都、竹宮惠子为代表的\u201C花之24年组\u201D漫画家开始在少女漫画中探索女性之间的情感关系。</p>
    <h2>平成时代：百合文化的黄金发展期</h2>
    <p>进入平成时代后，专门的百合漫画杂志创刊，百合动画也开始大量涌现。从《少女革命》到《圣母在上》，再到《魔法少女小圆》，百合元素在各种类型作品中不断丰富和深化。</p>`,
    category: "cp",
    categoryName: "百合CP",
    coverImage: "https://readdy.ai/api/search-image?query=Vintage%20Japanese%20aesthetic%20collage%20with%20old%20manga%20pages%2C%20cherry%20blossoms%2C%20antique%20books%2C%20traditional%20Japanese%20patterns%2C%20soft%20sepia%20and%20pink%20tones%2C%20nostalgic%20literary%20atmosphere%2C%20elegant%20historical%20feel&width=800&height=500&seq=yuri-article-12&orientation=landscape",
    author: "文化部",
    date: "2026-06-28",
    readTime: 14,
    tags: ["文化历史", "百合文化", "S文学", "发展史"],
    featured: false,
  },
];

export const communityStats = {
  totalMembers: 128960,
  totalArticles: 3562,
  totalComments: 45280,
  monthlyActiveUsers: 18600,
};